import { MembershipFeePageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import {IPerson} from "@shared/integrations/taf-api/v2/models";
import Alerts from '@shared/components/Alerts';


interface IMemberFeeProps {
    member: IPerson;
    openForm: () => void;
    content: MembershipFeePageContentResponseModel;
}

const MemberFee = ({ member, content, openForm }: IMemberFeeProps) => {
    return (
        <>
            <h1 className='page-title'>Medlemsavgift</h1>
            {content?.properties?.importantMessages && (
                <div className='mb-4'>
                    <Alerts alerts={content?.properties?.importantMessages} />
                </div>
            )}
            <div className='slide-up-fade-in'>
                <div className='card card-body mb-4'>
                    <div className='row'>
                        <div className='col-12'>
                            {/*{member.balance < 0 &&*/}
                            {/*    <PaymentReminder balance={member.balance} accountNumber="661-9969" referenceNumber={member.ocrNumber} />*/}
                            {/*}*/}
                            <h3>Betalsätt</h3>
                            <div className='ft-table ft-responsive-sm table-mark-empty font-size-sm'>
                                <div className='ft-tbody'>
                                    <div className='ft-tr'>
                                        <div className='ft-th'>Nuvarande betalsätt</div>
                                        <div className='ft-td '>{member.paymentMethod}</div>
                                    </div>
                                    <div className='ft-tr'>
                                        <div className='ft-th'>OCR nummer</div>
                                        <div className='ft-td'>{member.ocrNumber}</div>
                                    </div>
                                    {member.balance !== undefined && member.balance !== null && member.balance < 0 && (
                                        <div className='ft-tr'>
                                            <div className='ft-th'>Utestående belopp</div>
                                            <div className='ft-td highlight-mask'>{Math.abs(member.balance)} kr</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='d-flex justify-content-sm-end my-4'>
                                <button
                                    className='btn btn-outline-primary'
                                    type='button'
                                    onClick={() => openForm()}
                                >
                                    Ansök om autogiro
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MemberFee;
